import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Manifesto from "./components/Manifesto";
import Services from "./components/Services";
import Process from "./components/Process";
import Testimonials from "./components/Testimonials";
import Founder from "./components/Founder";
import Contact from "./components/Contact";

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Manifesto />
      <Services />
      <Process />
      <Testimonials />
      <Founder />
      <Contact />
    </main>
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
